import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import type { ContactFilters, ContactTypeFilter, MarketingOptOutFilter } from '@/lib/contacts/types'

export function ContactsToolbar({
  filters,
  onChange,
}: {
  filters: ContactFilters
  onChange: (filters: ContactFilters) => void
}) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <Select
        value={filters.contactType}
        onValueChange={(contactType) =>
          onChange({ ...filters, contactType: contactType as ContactTypeFilter })
        }
      >
        <SelectTrigger aria-label="Contact type" className="w-40">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All types</SelectItem>
          <SelectItem value="person">Person</SelectItem>
          <SelectItem value="organization">Organization</SelectItem>
        </SelectContent>
      </Select>
      <Select
        value={filters.marketingOptOut}
        onValueChange={(marketingOptOut) =>
          onChange({ ...filters, marketingOptOut: marketingOptOut as MarketingOptOutFilter })
        }
      >
        <SelectTrigger aria-label="Marketing Opt-out" className="w-44">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All opt-out states</SelectItem>
          <SelectItem value="opted_out">Opted out</SelectItem>
          <SelectItem value="not_opted_out">Not opted out</SelectItem>
        </SelectContent>
      </Select>
      <div className="flex items-center gap-2">
        <Checkbox
          id="include-archived"
          checked={filters.includeArchived}
          onCheckedChange={(checked) => onChange({ ...filters, includeArchived: checked === true })}
        />
        <Label htmlFor="include-archived" className="text-muted-foreground">
          Include archived
        </Label>
      </div>
    </div>
  )
}
